import type { Components } from '@mui/material/styles';
import type { Theme } from '../types';
import 'src/styles/theme.scss';

export const MuiCssBaseline = {
    // Pulled from App.scss to help prevent MUI from making unintentional visual changes as we convert components to it
    styleOverrides: {
        body: {
            backgroundColor: 'var(--bg-primary)',
            margin: 0,
            padding: 0,
            fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans","Droid Sans", "Helvetica Neue", sans-serif',
            '-webkit-font-smoothing': 'antialiased',
            '-moz-osx-font-smoothing': 'grayscale',
            height: '100%',
            width: '100%',
        },
        '#root': {
            display: 'inline',
        },
        '#router': {
            display: 'inline',
        },
        html: {
            margin: 0,
            padding: 0,
            height: '100%',
            width: '100%',
        },
        '.app': {
            margin: 0,
            padding: 0,
            height: '100%',
            width: '100%',
        },
    },
} satisfies Components<Theme>['MuiCssBaseline'];
